import { withInstall } from '../utils'
import _RateStar from './RateStar'
import './index.scss'

export const RateStar = withInstall(_RateStar)
export default RateStar
